import H from 'constants/httpMethod.const';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import actionEndpointBe from 'utils/mw/actionEndpointBe.util';

export const beDeleteTax = actionEndpointBe('beDeleteTax', H.del, 'sales/salon/:salonId/taxes/:id/', (options, extra) => ({
  ...options,
  inert: true,
  params: { id: fromAnyToTrimmed(extra?.id) },
}));
